import {createRouter, createWebHistory} from 'vue-router'
import Home from '@/views/Home.vue'
import HelferEingabe from "@/views/HelferEingabe.vue";
import Login from "@/views/Login.vue";
import unitDashboard from "@/views/unitDashboard.vue";
import AdminDashboard from "@/views/admin/AdminDashboard.vue";
import AdminUsers from "@/views/admin/AdminUsers.vue";
import AdminPersonalSearch from "@/views/admin/AdminPersonalSearch.vue";
import Verpflegung from "@/views/Verpflegung.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/reg',
        name: 'Registrierung',
        component: HelferEingabe
    },
    {
        path: '/helferedit/:id',
        name: 'Bearbeiten',
        component: HelferEingabe
    },
    {
        path: '/admin/helferedit/:id',
        name: 'AdminHelferBearbeiten',
        component: HelferEingabe
    },
    {
        path: '/unitdashboard',
        name: 'Dashboard',
        component: unitDashboard
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "/admin/dashboard",
        name: "AdminDashboard",
        component: AdminDashboard
    },
    {
        path: "/admin/users",
        name: "AdminUsers",
        component: AdminUsers
    },
    {
        path: "/admin/helfer",
        name: "AdminPersonalSearch",
        component: AdminPersonalSearch
    },
    {
        path: "/verpflegung",
        name: "Verpflegung",
        component: Verpflegung
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
